import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AdminPage from "../pages/admin/page";
import ReglamentoPage from "../pages/reglamento/page";
import InscribirsePage from "../pages/inscribirse/page";
import RecorridoPage from "../pages/recorrido/page";
import VerificarPage from "../pages/verificar/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/inscribirse",
    element: <InscribirsePage />,
  },
  {
    path: "/recorrido",
    element: <RecorridoPage />,
  },
  {
    path: "/verificar",
    element: <VerificarPage />,
  },
  {
    path: "/reglamento",
    element: <ReglamentoPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
